import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function normalizeWeightToTons(input: any): number | null {
  if (input == null) return null;

  let str = String(input).trim();

  if (str === "") return null;

  // Replace commas used as decimal separators (but keep thousand separators intact)
  // First, unify all commas and periods
  str = str.replace(/,/g, ".");
  // Extract the numeric part (allowing decimals)
  const match = str.match(/[\d.]+/);
  if (!match) return null;

  let value = parseFloat(match[0]);
  if (isNaN(value)) return null;

  const lower = str.toLowerCase();

  // If it explicitly says "kg", assume kilograms
  if (lower.includes("kg") || lower.includes("kilogram")) {
    value = value / 1000;
  }

  // Heuristic: if number is clearly too big (>1000), it's probably in kg
  else if (value > 1000) {
    value = value / 1000;
  }

  // Otherwise assume tons already

  return Math.round(value * 100) / 100;
}
